import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfigService } from 'src/app/demo/service/config.service';
import { Option } from 'src/app/demo/interfaces/form-print.interface';
import { AlertsService } from '../../service/alerts.service';
import { CrudService } from 'src/app/demo/service/crud.service';
import { AuthService } from 'src/app/demo/service/auth.service';
import { StorageService } from 'src/app/utils/storage.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-validity',
  templateUrl: './validity.component.html',
  styleUrl: './validity.component.scss'
})
export class ValidityComponent implements OnInit {
  validity: number | null = null;
  validities: Option[] = [];
  @Output() onValiditySelected: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private alertService: AlertsService,
    private crudService: CrudService,
    private authService: AuthService,
    private storage: StorageService,

  ) { }

  async ngOnInit() {
    let $storage = this.storage.get<any>('vigencia/all', 'local');
    let list = $storage ?? await this.queryGetList('vigencia/all', { state: 1 }, null);
    if ($storage === undefined || $storage === null) this.storage.set('vigencia/all', list, 'local');

    const vigencia = list.find(anio => anio.ano === new Date().getFullYear());
    this.validities = list.map((item: any) => ({ value: item.id, text: item.nombre }));

    $storage = this.storage.get<any>('selected_validity', 'local');
    const id_vigencia = $storage ?? vigencia.id;
    if ($storage === undefined || $storage === null) this.storage.set('selected_validity', vigencia.id, 'local');
    this.validity = id_vigencia;

    this.crudService.putData({ url: `vigencia/cambiar_vigencia/${this.validity}`, formData: {} }).subscribe(res_vig => {
      this.storage.set('token', res_vig.token, 'local')
    });

    // const user = this.authService.decodeTokenUser();
    // this.validity = user.vigencia;
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2024-11-12
    * Metodo que actualiza la vigencia dentro del sistema.  
  */
  onChangeValueOnSelect(event: any): void {
    const starageKey: string = 'token';
    const storageType = 'local';
    this.alertService.showConfirmAlert({ html: '¿Desea cambiar la vigencia seleccionada?' }).then(res => {
      if (res.isConfirmed) {
        this.storage.set('selected_validity', event.value, 'local');

        this.crudService.putData({ url: `vigencia/cambiar_vigencia/${this.validity}`, formData: {} }).subscribe(res_vig => {
          this.storage.set(starageKey, res_vig.token, storageType)
          window.location.reload();
        });
      }
    });
  }

  async queryGetList(endpointName: string, filter: any | null, pagination: any | null): Promise<any> {
    try {
      const res: any = await lastValueFrom(
        this.crudService.getData({ url: endpointName, filterForm: filter, pagination })
      );
      return res.data ?? [];
    } catch (err) {
      console.error('❌ Error al consultar:', err);
      throw err;
    }
  }
}